<script>
import resources from './resources'

export default {
  name: 'agendas-search-results-schedule',
  mixins: [resources]
}
</script>

<template lang="pug">
  div
    .row.text-center
      .loading-screen(v-show='mbloading', v-bind:class='classes', v-bind:style='{backgroundColor:bc}')
            component(v-if='customLoader', v-bind:is='customLoader')
            div(v-else='')
              .loading-circle
              p.loading-text
                strong {{ text }}
      div(v-if="showTotal")
        .row
          .col-xs-12.col-sm-12
              h6.custom-color
                strong Próxima Consulta:
              div
                .total.custom-color
                  strong {{ getDay }}
          .col-xs-12.col-sm-12

          .col-xs-12.col-sm-12
            h6.custom-color
              strong Horários Disponíveis:
            div
              .total.custom-color
                strong {{ agenda.total_agendas }}
        .row
          .col-xs-12.col-sm-12
            a.mb-cursor-pointer(@click.prevent="doSearchSchedules(agenda)")
              #search
                span.icon 
                | Ver Horários
    slide-up-down(:active="show", :duration="1000", style="height: 270px;", v-if="show")
        .agendas.label-times
          .h5-title.text-center
            h5
              i.fa.fa-calendar &nbsp;
              strong Horários de Atendimento
        table.table.f-z-14
          thead
            tr
              th Dia
              th
              th Hora
              th
          tbody
              tr(v-for="(item, index) in schedules", :key="index")
                th.data {{ parsedDayDate(item.date) }}
                td(v-for="(ia, i) in item.times.split(';')")
                  a.f-color(@click.prevent="toPreSchedule(item, i)", style="text-decoration: none;")
                    |{{ ia.slice(0,5) }}
                td(v-if="item.times.split(';').length < 4")
                  .availabilities-empty-slot-dash
                td(v-if="item.times.split(';').length < 3")
                  .availabilities-empty-slot-dash
                td(v-if="item.times.split(';').length < 2")
                  .availabilities-empty-slot-dash
                td(v-if="item.times.split(';').length < 1")
                  .availabilities-empty-slot-dash
</template>
<style scoped>
h6 {
    font-size: 15px;
}
h6 {
    margin-top: 9px;
    margin-bottom: -9px;
}
.mt-35 {
  margin-top: 35px;
}
.custom-color {
  color: #555555
}
.total {
  font-size: 30px;
  position: relative;
  color: #333344;
  margin-top: 5px;
  text-align: center;
}
#search {
  display: inline-block;
  background: #0c6bb5;
  color: #FFFFFF;
  font-size: 16px;
  border-radius: 50px;
  padding: 6px 20px 6px 25px;
  -webkit-transition: color ease .3s, padding ease .3s;
  transition: color ease .3s, padding ease .3s;
  margin-top: 0px;
}
.availabilities-empty-slot-dash {
    margin: 9px auto;
    width: 12px;
    height: 2px;
    background-color: rgba(67, 95, 113, 0.2);
    border-radius: 1px;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #ddd;
}
.label-times {
  color: #2071b9;
  margin-top: 40px;
}
.f-z-14 {
  font-size: 14px;
}
.f-color {
  color: #888888;
}
.f-color:hover {
  font-weight: bold;
  color: #fff;
}
.table {
    margin-top: 10px;
    color: #898989;
    text-align: center;
    cursor: default;
}
.table th {
    color: #1384d8;
    text-align: center;
}
.table td {
  border-radius: 30px;
}

.table td:hover {
  background: #1384D8;
  color: #FFFFFF;
  cursor: pointer;
}
@media (max-width: 767px){
}
.mb-cursor-pointer {
  cursor: pointer;
}
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30%;
  width: 100%;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 300;
  flex-direction: column;
  user-select: none;
  border-radius: 5px;
}
.loading-circle {
  margin-left: 35%;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-left-color: #387ab9;
  animation: circleanimation .45s linear infinite
}
.loading-text {
  margin-top: 15px;
  color: #387ab9;
  font-size: 14px;
  font-weight: 600;
}
@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-professional/components/schedule/schedule.vue